/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleAudioModel } from '../../models/article-audio-model';

export interface ArticlePublisherIdIdAudioLanguageIdPost$Plain$Params {
  publisherId: string;
  id: string;
  languageId: string;
      body?: ArticleAudioModel
}

export function articlePublisherIdIdAudioLanguageIdPost$Plain(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdAudioLanguageIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdAudioLanguageIdPost$Plain.PATH, 'post');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<string>;
    })
  );
}

articlePublisherIdIdAudioLanguageIdPost$Plain.PATH = '/Article/{publisherId}/{id}/Audio/{languageId}';
